import { ModalBody } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import FormWithProvider from 'components/forms/form/Form';
import FormFieldset from 'components/forms/form/FormFieldset';
import { ScheduledMessage } from 'models/automation/ScheduledMessages';
import ScheduledMessagesSendNowModalFooter from './ScheduledMessagesSendNowModalFooter';
import useScheduledMessageSendNowModalFormSubmit from './useScheduledMessageSendNowModalFormSubmit';

interface ScheduledMessagesSendNowModalProps {
  scheduledMessage: ScheduledMessage;
}

const ScheduledMessagesSendNowModal = ({
  scheduledMessage,
}: ScheduledMessagesSendNowModalProps) => {
  const { t } = useTranslation();

  const { onSubmit } = useScheduledMessageSendNowModalFormSubmit({
    scheduledMessage,
  });

  return (
    <FormWithProvider defaultValues={{}} onSubmit={onSubmit} noValidate>
      <FormFieldset>
        <ModalBody>
          <p>
            {t('pageAutomations.scheduledMessages.modalSendNow.body', {
              name: scheduledMessage.messageName,
              recipients: scheduledMessage.triggerRecipients?.join(', ') ?? '-',
            })}
          </p>
        </ModalBody>
        <ScheduledMessagesSendNowModalFooter
          scheduledMessage={scheduledMessage}
        />
      </FormFieldset>
    </FormWithProvider>
  );
};

export default ScheduledMessagesSendNowModal;
